export default "__VITE_ASSET__D99xsBSK__"